
/**
 * 응답 데이터
 * @nullable
 */
export type NicePayReturn200Data = { [key: string]: unknown } | null;
